import { Box, IconButton } from '@mui/material';
import { Check, X } from 'lucide-react';

import { useLocale } from '@shared/hooks/locale';

type SaveCancelButtonsProps = {
  onSave: () => void;
  onCancel: () => void;
  disabled?: boolean;
};

export const SaveCancelButtons = ({
  onSave,
  onCancel,
  disabled,
}: SaveCancelButtonsProps) => {
  const { t } = useLocale();
  return (
    <Box sx={{ display: 'flex', gap: 0.25, flexShrink: 0, pt: '2px' }}>
      <IconButton
        size="small"
        color="success"
        onClick={onSave}
        disabled={disabled}
        sx={{
          width: 28,
          height: 28,
          '&:hover': { backgroundColor: 'transparent' },
        }}
        title={t('Save')}
      >
        <Check size={16} />
      </IconButton>
      <IconButton
        size="small"
        onClick={onCancel}
        disabled={disabled}
        sx={{
          width: 28,
          height: 28,
          color: 'text.secondary',
          '&:hover': { backgroundColor: 'transparent' },
        }}
        title={t('Cancel')}
      >
        <X size={16} />
      </IconButton>
    </Box>
  );
};
